import {
  collectDebtOwners,
  mergeDebtOwner,
  type CashbookDebtEntryRecord,
  type CashbookOpeningDebtLine,
  type CashbookSettings
} from '@finvox/shared/cashbook';

/** Merge named owners from debt entries, opening lines, and an existing registry. */
export function mergeDebtOwnerRegistry(
  entries: CashbookDebtEntryRecord[],
  settings: CashbookSettings,
  previous: string[] = []
): string[] {
  let merged = collectDebtOwners(entries, settings);
  for (const name of previous) {
    merged = mergeDebtOwner(merged, name);
  }
  for (const line of settings.openingDebtLines ?? []) {
    if (line.creditor.trim()) {
      merged = mergeDebtOwner(merged, line.creditor);
    }
  }
  return merged;
}

export function openingDebtLinesFromSummary(
  lines: CashbookOpeningDebtLine[] | undefined
): CashbookOpeningDebtLine[] {
  return lines ?? [];
}
